import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useTable } from '@app/components';
import { Strings } from '@app/constants';
import { useRequestState, useSearch } from '@app/hooks';
import { Header } from '@app/sections/header';
import { getProjects, selectProjectState } from '@app/modules/projects';
import { EtaList } from './eta-list';
import { getAllTaskEta } from '../slice';
import { selectAllTaskEtaState } from '../selectors';
import { IEtaExportField } from '../constants';

const EtaListPage = () => {
  const dispatch = useDispatch();
  const tableProps = useTable();

  const [selectedProjectName, setSelectedProjectName] = useState<string>('');
  const { data } = useRequestState({
    stateSelector: selectProjectState,
    errorShown: true,
  });
  const { data: allTaskEtaData } = useRequestState({
    stateSelector: selectAllTaskEtaState,
  });

  const { handleSearchChange, filteredRows } = useSearch({
    data: allTaskEtaData ?? [],
    fields: ['taskName', 'description', 'expectedEta', 'actualEta', 'status'],
  });

  useEffect(() => {
    dispatch(getProjects());
  }, [dispatch]);

  useEffect(() => {
    if (data?.projects?.length && !selectedProjectName) {
      const defaultProjectName = data.projects[0].name;
      setSelectedProjectName(defaultProjectName);
      const defaultProjectId = data.projects[0].id;
      dispatch(getAllTaskEta({ projectId: defaultProjectId }));
    }
  }, [data, selectedProjectName, dispatch]);

  const handleProjectSelect = (projectName: string) => {
    setSelectedProjectName(projectName);
    const selected = data?.projects?.find((proj: any) => proj.name === projectName);
    if (selected) {
      dispatch(getAllTaskEta({ projectId: selected.id }));
    }
  };

  const tableHeadCsv = [
    { key: IEtaExportField.TaskName, label: Strings.eta.taskName },
    { key: IEtaExportField.Description, label: Strings.eta.description },
    { key: IEtaExportField.ExpectedEta, label: Strings.eta.expectedTime },
    { key: IEtaExportField.ActualEta, label: Strings.eta.actualTime },
    { key: IEtaExportField.Status, label: Strings.eta.status },
  ];

  return (
    <>
      <Header
        title={Strings.page_title.eta}
        helperText=""
        searchBarProps={{
          placeholder: Strings.common.search,
          onChange: handleSearchChange,
        }}
        dropDownSelect={selectedProjectName}
        dropDownLabel={Strings.field.projectName}
        dropDownOptions={data?.projects?.map((proj: any) => proj.name) ?? []}
        onClickDropDownOption={handleProjectSelect}
        exportedData={{
          rows: filteredRows ?? [],
          tableHeadCsv,
          csvName: 'eta-list-page',
        }}
        additionalExportButtonTitle={Strings.button.export}
      />

      <EtaList loading={false} tableProps={tableProps} rows={filteredRows ?? []} />
    </>
  );
};

export { EtaListPage };
